import React from 'react';
import { useThrottleFn, useMount, useUnmount } from 'ahooks';

import type { EChartsType } from 'echarts';

/**
 * ECharts图表resize hooks
 * 处理ECharts图表的resize功能
 * @param chartInstance echarts实例
 */
export default function useChartResize(chartInstance: React.RefObject<EChartsType>) {
  const { run: handleResize } = useThrottleFn(
    () => {
      setTimeout(() => {
        if (chartInstance?.current) {
          chartInstance.current.resize();
        }
      });
    },
    {
      // 等待时间，单位为毫秒
      wait: 600,
      // 是否在延迟开始前调用函数
      leading: true,
      // 是否在延迟开始后调用函数
      trailing: true,
    },
  );

  /**
   * 组件加载时监听window的resize事件，处理echarts图表的resize
   */
  useMount(() => {
    window.addEventListener('resize', handleResize, false);
  });

  /**
   * 组件卸载时，移除window的resize事件监听器
   */
  useUnmount(() => {
    window.removeEventListener('resize', handleResize, false);
  });
}
